var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',_vm._b({attrs:{"text-inside":_vm.textInside,"stroke-width":_vm.strokeWidth,"percentage":_vm.percentage,"color":_vm.customColors}},'el-progress',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }